export const services = {
  headers: {
    requestedService: "Serviço solicitado",
  },
  actions: {
    discardRequest: "Descartar solicitação",
  },
  storeInactiveTitle: "A loja de serviços não está ativa",
  storeInactiveDesc1:
    "Para receber solicitações de experiências e serviços adicionais, você precisa ativar sua loja.",
  storeInactiveDesc2:
    "Depois de ativada, seus hóspedes podem solicitar serviços diretamente pelo WhatsApp.",
  activateStoreBtn: "Ativar loja de serviços",

  noServicesDesc1:
    "Ative as Experiências configurando seus serviços adicionais: café da manhã, passeios, traslados ou o que você oferecer.",
  noServicesDesc2:
    "Seus hóspedes os verão logo após o check-in, diretamente no WhatsApp.",
  addFirstServiceBtn: "Adicionar minha primeira experiência ou serviço",
};
